/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `incomplete` - Incomplete * `incomplete_expired` - Incomplete Expired * `trialing` - Trialing * `active` - Active * `past_due` - Past Due * `unpaid` - Unpaid * `canceled` - Canceled
 * @export
 * @enum {string}
 */
export enum SubscriptionStatusEnum {
    Incomplete = 'incomplete',
    IncompleteExpired = 'incomplete_expired',
    Trialing = 'trialing',
    Active = 'active',
    PastDue = 'past_due',
    Unpaid = 'unpaid',
    Canceled = 'canceled'
}



